module.exports = __webpack_public_path__ + "static/img/05.fbf8ae9b.png";